module.exports = __webpack_public_path__ + "static/media/iv_refer_and_earn.bca43ef4.svg";